var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardTc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#2E7DE0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8142 18.0007C14.566 18.0007 15.2112 17.9613 15.7503 17.8414C16.2962 17.7201 16.7694 17.5086 17.1385 17.1395C17.5076 16.7704 17.7191 16.2972 17.8405 15.7512C17.9603 15.2122 17.9998 14.567 17.9998 13.8152V12.0008C17.9998 11.338 17.4625 10.8008 16.7998 10.8008H11.9998C11.337 10.8008 10.7998 11.338 10.7998 12.0008V16.8007C10.7998 17.4635 11.337 18.0007 11.9998 18.0007H13.8142Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 13.8152C6 14.567 6.0395 15.2122 6.15931 15.7512C6.28063 16.2972 6.49212 16.7704 6.86125 17.1395C7.23038 17.5086 7.70359 17.7201 8.24947 17.8414C8.30175 17.853 8.35429 17.8639 8.40705 17.8741C9.05775 17.9998 9.59998 17.4491 9.59998 16.7863V12.0008C9.59998 11.338 9.06272 10.8008 8.39998 10.8008H7.19999C6.53725 10.8008 6 11.338 6 12.0008V13.8152Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1852 6C9.43332 6 8.78818 6.0395 8.2491 6.15931C7.70321 6.28063 7.23001 6.49212 6.86088 6.86125C6.49175 7.23038 6.28026 7.70359 6.15894 8.24947C6.14898 8.2943 6.1396 8.33927 6.1308 8.38437C6.00218 9.04358 6.56298 9.59998 7.23462 9.59998H16.7852C17.4479 9.59998 17.9987 9.05775 17.873 8.40705C17.8628 8.35429 17.8518 8.30175 17.8403 8.24947C17.7189 7.70359 17.5074 7.23038 17.1383 6.86125C16.7692 6.49212 16.2959 6.28063 15.7501 6.15931C15.211 6.0395 14.5658 6 13.814 6H10.1852Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardTc);
export default __webpack_public_path__ + "static/media/dashboard_tc.7afbd1b6b4cd4f62d67239ce1fcf8129.svg";
export { ForwardRef as ReactComponent };